"use client";
import { jsxs as s, jsx as l } from "react/jsx-runtime";
const h = ({
  title: r,
  titleId: e,
  desc: i,
  descId: t,
  ...a
}) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-lt",
    viewBox: "0 0 640 480",
    "aria-labelledby": e,
    "aria-describedby": t,
    ...a,
    children: [
      i ? /* @__PURE__ */ l("desc", { id: t, children: i }) : null,
      r ? /* @__PURE__ */ l("title", { id: e, children: r }) : null,
      /* @__PURE__ */ s("g", { fillRule: "evenodd", strokeWidth: "1pt", transform: "scale(.64143 .96773)", children: [
        /* @__PURE__ */ l(
          "rect",
          {
            width: 1063,
            height: 708.7,
            fill: "#006a44",
            rx: 0,
            ry: 0,
            transform: "scale(.93865 .69686)"
          }
        ),
        /* @__PURE__ */ l(
          "rect",
          {
            width: 1063,
            height: 236.2,
            y: 475.6,
            fill: "#c1272d",
            rx: 0,
            ry: 0,
            transform: "scale(.93865 .69686)"
          }
        ),
        /* @__PURE__ */ l("path", { fill: "#fdb913", d: "M0 0h997.8v164.6H0z" })
      ] })
    ]
  }
);
export {
  h as default
};
